<template>
  <div>
    <div class="main">
      <div class="information">
        当前就诊人：*成成
        <button>切换</button>
      </div>
      <div class="options">
        <van-tabs v-model="active">
          <van-tab title="检验">检验</van-tab>
          <van-tab title="检查">检查</van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0
    }
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>

<style scoped>
.information {
  color: #ffffff;
  background-color: rgb(8, 112, 253);
  padding: 7px 10px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.information button {
  background-color: #ffffff;
  font-size: 18px;
  color: rgb(79, 188, 251);
  border: 1px solid rgb(8, 112, 253);
  border-radius: 20px;
}
.options /deep/ .van-tabs__line {
  width: 50%;
  height: 2px;
  background-color: rgb(8, 112, 253);
}
</style>
